import { useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'
import * as yup from 'yup'

export interface ITruckAvailability {
  pickup: ILocationSuggestion
  pickupDate: string
  dropoffPreference: string
  radius?: number
  haulType?: string
  delivery?: ILocationSuggestion
}

export const TTruckAvailabilitySchema = yup
  .object<ITruckAvailability>({
    pickup: yup.object<ILocationSuggestion>().required('Pickup city is required'),
    pickupDate: yup.string().required('Pickup state is required'),
    dropoffPreference: yup.string(),
    radius: yup.number(),
    haulType: yup.string(),
    delivery: yup.object<ILocationSuggestion>(),
  })
  .required()

export type TTruckAvailabilitySchema = yup.InferType<typeof TTruckAvailabilitySchema>

type TOmittedProps = 'mode' | 'resolver' | 'defaultValues'

interface IUseTruckAvailabilityFormProps
  extends Omit<UseFormOptions<TTruckAvailabilitySchema>, TOmittedProps> {
  formDefaultValues?: Partial<ITruckAvailability>
}

export const useTruckAvailabilityForm = (props: IUseTruckAvailabilityFormProps = {}) => {
  const { formDefaultValues } = props || {}
  const {
    pickup = undefined,
    pickupDate = undefined,
    dropoffPreference = 'haul',
    radius = undefined,
    haulType = undefined,
    delivery = undefined,
  } = formDefaultValues || {}
  return useForm<TTruckAvailabilitySchema>({
    mode: 'all',
    resolver: yupResolver(TTruckAvailabilitySchema),
    shouldUnregister: false,
    defaultValues: TTruckAvailabilitySchema.cast({
      pickup,
      pickupDate,
      dropoffPreference,
      radius,
      haulType,
      delivery,
    }),
    ...props,
  })
}
